<template>

    <div>
        <label for="name">Email Name</label>
        <input type="text" id="name" v-model="email.name" class="form-control">
        <br />

        <label for="editor">Content</label>
        <div id="editor"  name="editordata" v-html="email.content"></div>
        <br />
        <button class="btn btn-primary" @click="save">Save</button>

    </div>
</template>


<script type="text/babel">
    var TableCellBackground = function (context) {
        var ui = $.summernote.ui;

        // create button
        var button = ui.button({
            contents: '<i class="fa fa-child"/> Hello',
            tooltip: 'hello',
            click: function () {
                // invoke insertText method with 'hello' on editor module.
                context.invoke('editor.backgroundColor');
            }
        });
        return button.render();   // return button as jquery object
    }

    export default {
        name: 'Editor',
        data: function () {
            return {
                email:{},
                $editor: null,
                table: null,
                showTableOptions: false
            }
        },
        components: {},
        mounted(){
            this.$editor = $('#editor');
            this.$editor.summernote({
                toolbar: [
                    ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
                    ['fontsize', ['fontsize']],
                    ['forecolor'],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['codeview'],

                ],
                popover:{
                   table:[
                       ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
                       ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
                       ['custom', ['tableCellStyle']]
                   ]
                },
                buttons: {
                    tablecell: TableCellBackground
                },
                height: 300,                 // set editor height
                minHeight: 300,             // set minimum height of editor
                maxHeight: null,             // set maximum height of editor
                focus: true                  // set focus to editable area after initializing summernote
            });
        },
        created(){

            this.email = JSON.parse(JSON.stringify(this.selected))
        },
        beforeDestroy(){
            this.$editor.summernote('destroy');
        },
        props: ['selected'],
        methods: {
            save(){
                this.email.content = this.$editor.summernote('code');
                this.$emit('saveEmail', this.email);
            }
        },
    }


</script>

<style>
    #editor{
        border: 1px solid #e2e2e2;
        width: 600px;
        margin: 0 auto;
    }
    button.note-btn {
        border: 1px solid #ccc;
    }
    button.note-btn.active {
        background: #e2e2e2;
    }

    .popover-content .note-dropdown-menu{
        min-width: 200px;
    }
    .popover-content .note-dropdown-menu .note-color-btn{
        height: 20px;
        border: 1px solid #FFF;
    }
    .popover-content .note-dropdown-menu .note-color-select{
        width: 100%;
        padding: 2px 3px;
        margin: 3px;
        cursor: pointer;
        background-color: #fff;
        border: 0;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }

    .popover-content .note-dropdown-menu .note-holder-custom .note-color-btn {
        border: 1px solid #eee;
    }

    .popover-content .note-dropdown-menu .note-color-select-btn {
        display: none;
    }

    .popover-content .note-dropdown-menu .note-palette .note-palette-title {
        margin: 2px 7px;
        font-size: 12px;
        text-align: center;
        border-bottom: 1px solid #eee;
    }

    .popover-content .note-dropdown-menu .note-palette .note-color-reset{
        width: 100%;
        padding: 2px 3px;
        margin: 3px;
        cursor: pointer;
        background-color: #fff;
        border: 0;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }

    .note-editor .note-editing-area .note-editable table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 0;
        table-layout: fixed

    }
    .note-editor .note-editing-area .note-editable table td {
        padding: 5px;
    }

    .note-editor .note-editing-area .note-editable table td p{
        margin: 0;
        padding: 0
    }

    .note-current-color-button{
        border: none;
        background: none;

    }
    /*.note-editor .note-editing-area .note-editable table td:first-child:last-child{*/
        /*background: #000;*/
        /*color: white;*/

    /*}*/

    /*.note-editor .note-editing-area .note-editable table tr:nth-child(odd){*/
        /*background: #f7f7f7;*/
    /*}*/


</style>


// WEBPACK FOOTER //
// Editor.vue?0fdea2c5